import { createBrowserRouter } from "react-router-dom";
import About from "../components/About";
import Blog from "../components/Blog";
import Contact from "../components/Contact";

import Home from "../components/Home";
import MyCompo from "../components/Mycompo/MyCompo";

import Navbar from "../components/Navbar";
import Skills from "../components/Skills";
import Work from "../components/Work";
import Main from "../layout/Main";
import BikeFranzy from "../components/Projects/BikeFranzy";
import CodeVerse from "../components/Projects/CodeVerse";
import TravelG from "../components/Projects/TravelG";




const router = createBrowserRouter([
    {
        path:'/',
        element:<Main></Main>,
       children:[
        {
            path:'/',
            element:<MyCompo></MyCompo>
        },
        {
            path:'/details_One',
            element:<BikeFranzy></BikeFranzy>
        },
        {
            path:'/codeverse',
            element:<CodeVerse></CodeVerse>
        },
        {
            path:'/travel',
            element:<TravelG></TravelG>
        },
        {
            path:'/home',
            element:<MyCompo></MyCompo>
        },
       
        {
            path:'/details_two',
            element:<MyCompo></MyCompo>
        },
        {
            path:'/details_three',
            element:<MyCompo></MyCompo>
        },
        {
            path:'/details_Four',
            element:<MyCompo></MyCompo>
        },
       
       ]
       


    }
])

export default router;